import Vue from "vue";
import Vuex from "vuex";
import layout from './modules/layout';
import menu from './modules/menu';

import router from '../router/index';
import decode from 'jwt-decode';

Vue.use(Vuex);

//export const store = new Vuex.Store({
export default new Vuex.Store({
  state: {
    token: '',
    usuarioDB: ''
  },
  mutations: {
    obtenerUsuario(state, payload){  
      state.token = payload;
      if(payload === ''){
        state.usuarioDB = ''
      }else{
        state.usuarioDB = decode(payload);
        if(router.history.current.name=='login'){
          router.push({name: 'inicio'});
        }
      }
    }  
  },
  actions: {
    guardarUsuario({commit}, payload){
      localStorage.setItem('token', payload);
      commit('obtenerUsuario', payload);
      commit('menu/generarMenu', payload);
    },
    cerrarSesion({commit}){
      commit('obtenerUsuario', '');
      
      localStorage.removeItem('token');
      router.push({name: 'login'});
    },
    leerToken({commit}){
      const token = localStorage.getItem('token');
      if(token){
        commit('obtenerUsuario', token);
      }else{
        commit('obtenerUsuario', '');
      }
    }

  },
  modules: {
    layout,
    menu
  },
  getters:{
    estaActivo: state => !!state.token      
  }

});

